import { normalizeApiData } from './apiHelpers';

export const TIPO_TO_PREFIX = {
  caixa: 'CX',
  mala: 'ML',
  pallet: 'PL',
  container: 'CT',
};

export function prefixForTipo(tipo) {
  const t = String(tipo || '').toLowerCase().trim();
  return TIPO_TO_PREFIX[t] || 'CX';
}

/**
 * Maior sufixo numérico entre códigos que começam com o prefixo (ex.: só ML para malas).
 */
export function maxSuffixForPrefix(codes, prefix) {
  const p = prefix.toUpperCase();
  let max = 0;
  for (const raw of codes) {
    const code = String(raw || '').trim().toUpperCase();
    if (!code.startsWith(p)) continue;
    const rest = code.slice(p.length);
    if (!/^\d+$/.test(rest)) continue;
    const n = parseInt(rest, 10);
    if (!Number.isNaN(n) && n > max) max = n;
  }
  return max;
}

export function nextPackageCodeForPrefix(codes, prefix) {
  const next = maxSuffixForPrefix(codes, prefix) + 1;
  const width = Math.max(3, String(next).length);
  return `${prefix.toUpperCase()}${String(next).padStart(width, '0')}`;
}

export function nextPackageCodeForTipo(codes, tipo) {
  return nextPackageCodeForPrefix(codes, prefixForTipo(tipo));
}

/**
 * Lista todos os codigo_pacote/codigo (paginando) para o próximo número não repetir.
 */
export async function fetchAllPackageCodigos(getBoxes) {
  const codes = [];
  let page = 1;
  const perPage = 100;
  for (;;) {
    const response = await getBoxes({ page, per_page: perPage });
    const list = normalizeApiData(response);
    if (!Array.isArray(list) || list.length === 0) break;
    for (const box of list) {
      const c = box.codigo_pacote || box.codigo;
      if (c != null && String(c).trim() !== '') {
        codes.push(String(c).trim());
      }
    }
    const lastPage = response?.last_page ?? response?.lastPage;
    if (lastPage != null && page >= Number(lastPage)) break;
    if (list.length < perPage) break;
    page += 1;
  }
  return codes;
}
